import React, { FC } from "react";
import { faInstagram } from "@fortawesome/free-brands-svg-icons/faInstagram";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const Instagram: FC<JSX.IntrinsicAttributes> = (props) => {
  return <FontAwesomeIcon icon={faInstagram} {...props} />;
};
